import { render, staticRenderFns } from "./ContactDataForm.html?vue&type=template&id=437df6ca&external"
import script from "./ContactDataForm.ts?vue&type=script&lang=ts&external"
export * from "./ContactDataForm.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports